import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Instagram, Mail, FileText, Link2, Music2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ICONS = {
  instagram: Instagram,
  mail: Mail,
  epk: FileText,
  music: Music2,
  link: Link2,
};

export default function Links() {
  const [links, setLinks] = useState(null);

  useEffect(() => {
    document.title = "Links | TONE";
    fetch(`${API}/links`)
      .then((r) => r.json())
      .then(setLinks)
      .catch(() => setLinks([]));
    return () => {
      document.title = "TONE — Emotional Techno";
    };
  }, []);

  return (
    <main data-testid="links-page" className="min-h-screen bg-[#070709] text-[#f5f3ef] flex flex-col items-center px-6 py-16 md:py-24">
      <div className="noise-page grain" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md"
      >
        <div className="text-center">
          <p className="font-display font-extrabold uppercase tracking-tight leading-none text-5xl">TONE</p>
          <p className="mt-3 font-mono2 text-[10px] tracking-[0.4em] text-[#64646e] uppercase">
            Emotional Techno — @tonixsven
          </p>
          <div className="mt-5 mx-auto w-10 h-px bg-[#38bdf8]/60" />
        </div>

        <div className="mt-12 flex flex-col gap-3">
          {links === null ? (
            <p className="text-center font-mono2 text-[10px] tracking-[0.3em] text-[#64646e] uppercase">Lade…</p>
          ) : (
            links.map((l, i) => {
              const Icon = ICONS[l.icon] || Link2;
              return (
                <motion.a
                  key={l.id}
                  data-testid={`link-item-${i}`}
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, y: 14 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: 0.06 * i, ease: [0.16, 1, 0.3, 1] }}
                  className="group flex items-center justify-between border border-white/12 px-6 py-4 font-mono2 text-[11px] tracking-[0.25em] uppercase text-[#f5f3ef] hover:border-[#38bdf8]/70 hover:text-[#70c7fa] hover:shadow-[0_0_28px_rgba(56,189,248,0.15)] transition-all duration-500"
                >
                  <span className="flex items-center gap-3">
                    <Icon className="w-4 h-4 text-[#38bdf8]/80" />
                    {l.label}
                  </span>
                  <ArrowUpRight className="w-4 h-4 opacity-40 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
                </motion.a>
              );
            })
          )}
        </div>

        <div className="mt-14 flex items-center justify-center gap-6 font-mono2 text-[9px] tracking-[0.3em] text-[#64646e] uppercase">
          <Link data-testid="links-impressum" to="/impressum" className="hover:text-[#70c7fa] transition-colors">
            Impressum
          </Link>
          <Link data-testid="links-datenschutz" to="/datenschutz" className="hover:text-[#70c7fa] transition-colors">
            Datenschutz
          </Link>
          <Link data-testid="links-home" to="/" className="hover:text-[#70c7fa] transition-colors">
            tonesound.de
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
